import React, { useEffect, useState } from 'react';
import axios from "axios";
import { API_BASE_URL } from "../config";
import Loading from "../components/Loading";
import { toast, ToastContainer } from "react-toastify";
import ToastWithLink from "../components/Toast/ToastWithLink";

const Scripts = () => {

    const [desiredSize, setDesiredSize] = useState();
    const [fileName, setFileName] = useState('');
    const [filePath, setFilePath] = useState('');
    const [selectedServers, setSelectedServers] = useState([]);
    const [allServers, setAllServers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [toastStatus, setToastStatus] = useState('error');
    const [CSVFileName, setCSVFileName] = useState();

    // Data extracted from CSV
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [csvRows, setCsvRows] = useState([]);

    const loadScript = () => {
        if (!desiredSize || !fileName || !filePath || !selectedServers.length)
            return toast.error("Merci de renseigner tous les champs.");

        setIsLoading(true);

        axios.post(`${API_BASE_URL}/scripts/compare-filesize`, {
            fileSize: desiredSize,
            fileName: fileName,
            filePath: filePath,
            selectedServers: selectedServers
        })
            .then((res) => {

                if (res.status === 200) {
                    const { filePath } = res.data;
                    const downloadUrl = `${API_BASE_URL}/scripts/file/${filePath}`;

                    setToastStatus('success');
                    setCSVFileName(filePath);

                    toast.success(
                        <ToastWithLink
                            message={`Fichier créé. <a href="${downloadUrl}" target="_blank" rel="noopener noreferrer" >⬇️ Télécharger</a>`}
                        />
                    );

                    // Load CSV content
                    fetchAndDisplayCsv(filePath);
                }

                if (res.data.status === 400) {
                    setToastStatus('error');
                    toast.error("Merci de renseigner tous les champs.");
                }

            })
            .finally(() => setIsLoading(false));
    };


    // --- CSV PARSER + FIX FOR DUPLICATE HEADERS ---
    const fetchAndDisplayCsv = async (fileName) => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/scripts/file/${fileName}`,
                { responseType: 'text' }
            );

            const text = response.data;

            let lines = text.split(/\r?\n/).filter(line => line.trim() !== '');
            if (lines.length === 0) return;

            // First line = headers
            const headers = lines[0].split(',');

            // Data rows
            let rows = lines.slice(1).map(line => {
                const cols = line.split(',');
                const rowObj = {};
                headers.forEach((header, index) => {
                    rowObj[header] = cols[index] ?? '';
                });
                return rowObj;
            });

// Filter out any exact header duplicates (optional)
            rows = rows.filter(row => {
                const values = Object.values(row);
                const exactMatch = values.every((v, i) => v === headers[i]);
                const shiftedMatch = (!values[0] || values[0].trim() === "") &&
                    values.slice(1).every((v, i) => v === headers[i + 1]);
                return !(exactMatch || shiftedMatch);
            });

// Now remove the original second line (index 1)
            const finalRows = [
                rows[0],   // first row (data)
                // Mark what was originally the 3rd row as a header row
                { ...rows[1], _isHeaderRow: true },
                ...rows.slice(2)
            ];

            setCsvHeaders(headers);
            setCsvRows(finalRows);

        } catch (error) {
            console.error('Erreur CSV :', error);
            toast.error("Erreur lors de la lecture du fichier.");
        }
    };


    // Toggle one server
    const toggleServer = (value) => {
        setSelectedServers(prev =>
            prev.includes(value)
                ? prev.filter(s => s !== value)
                : [...prev, value]
        );
    };

    // Toggle all
    const toggleSelectAll = () => {
        setSelectedServers(
            selectedServers.length === allServers.length ? [] : allServers
        );
    };

    useEffect(() => {
        axios.post(`${API_BASE_URL}/scripts/get_all_servers`, {})
            .then((res) => setAllServers(res.data));
    }, []);


    return (
        <div>
            <ToastContainer position="bottom-right" autoClose={toastStatus === 'success' ? false : 3000}/>

            <h2 className={"color-third"}>Scripts</h2>

            <div className="container display-flex gap-20 flex-direction-column">

                <div className="display-flex flex-direction-column">
                    <label htmlFor="title" className="form-label color-third">Nom du fichier + .ext</label>
                    <input
                        className="input pl-10"
                        placeholder="index.php"
                        id="title"
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                    />
                </div>

                <div className="display-flex flex-direction-column">
                    <label htmlFor="path" className="form-label color-third">Chemin vers le fichier</label>
                    <input
                        className="input pl-10"
                        placeholder="wp-content/themes/SolutionDigitale/modules/mon-dossier"
                        id="path"
                        value={filePath}
                        onChange={(e) => setFilePath(e.target.value)}
                    />
                </div>

                <div className="display-flex flex-direction-column">
                    <label htmlFor="size" className="form-label color-third">Taille du fichier en octets</label>
                    <input
                        className="input pl-10"
                        type="number"
                        placeholder="15067"
                        id="size"
                        value={desiredSize}
                        onChange={(e) => setDesiredSize(parseInt(e.target.value))}
                    />
                </div>

                <label className="form-label">Hébergement(s) cible(s)</label>

                <div className="display-flex flex-direction-column">

                    <div className="display-flex flex-direction-row flexwrap-wrap">
                        {allServers.map((server) => (
                            <div key={server} className="w-50pc display-flex gap-20 my-5">
                                <input
                                    id={server}
                                    type="checkbox"
                                    onChange={() => toggleServer(server)}
                                    checked={selectedServers.includes(server)}
                                />
                                <label htmlFor={server} className="flex-1">{server}</label>
                            </div>
                        ))}
                    </div>

                    <span
                        onClick={toggleSelectAll}
                        className="text-underline cursor-pointer mt-10"
                    >
                        {selectedServers.length === allServers.length
                            ? "Tout désélectionner"
                            : "Tout sélectionner"}
                    </span>
                </div>
            </div>

            <button className="mt-20" onClick={loadScript}>
                Lancer le script
            </button>

            {isLoading && <Loading/>}

            {csvRows.length > 0 && (
                <div className="mt-20 container">
                    <h3 className="color-third mb-10">Aperçu du rapport : {CSVFileName}</h3>

                    <div className="table-wrapper" style={{ overflowX: 'auto' }}>
                        <table className="table w-100 table-scripts">
                            <thead>
                            <tr
                                className={"p-10"}>
                                {csvHeaders.map((header) => (
                                    <th key={header}
                                        className={"p-10 text-left"} >{header}</th>
                                ))}
                            </tr>
                            </thead>

                            <tbody>
                            {csvRows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {csvHeaders.map((header) => (
                                        <td
                                            className={"p-10"}
                                            key={header}
                                            style={{
                                                color:
                                                    row[header] === "Fichier introuvable"
                                                        ? "red"
                                                        : row[header] === "Fichier différent"
                                                            ? "orange"
                                                            : row[header] === "Fichier identique"
                                                                ? "green"
                                                                : "inherit",
                                                fontWeight:
                                                    row[header] === "Fichier différent" ||
                                                    row[header] === "Fichier introuvable" ||
                                                    row[header] === "Fichier identique"
                                                        ? "bold"
                                                        : row._isHeaderRow
                                                            ? "bold"
                                                            : "normal",
                                                backgroundColor: row._isHeaderRow ? "#f8f8f8" : "transparent",
                                            }}
                                        >
                                            {row[header]}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>

                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Scripts;
